import React, { useState, Component } from 'react';
import { motion } from 'framer-motion';
import { MailIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
export function ContactPage() {
  const {
    t
  } = useLanguage();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const subject = encodeURIComponent(`Contact from ${formData.name}`);
    const body = encodeURIComponent(`Name: ${formData.name}\nEmail: ${formData.email}\n\n${formData.message}`);
    window.location.href = `mailto:${t.contact.email}?subject=${subject}&body=${body}`;
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
  return <div className="max-w-6xl mx-auto px-4 md:px-6 py-8 md:py-12" data-id="element-88" data-mp="1qe1bqu2mc2k6">
      <motion.h1 initial={{
      opacity: 0,
      y: -20
    }} animate={{
      opacity: 1,
      y: 0
    }} className="text-3xl md:text-5xl font-bold mb-8 text-center text-[#2A4B7C]" data-id="element-89" data-mp="1qc6srlawqkiq">
        {t.contact.title}
      </motion.h1>
      <p className="text-center text-gray-600 mb-8 md:mb-12 text-lg" data-id="element-90" data-mp="hyfcqblm63sc">
        {t.contact.intro}
      </p>

      <div className="grid md:grid-cols-2 gap-6 md:gap-12" data-id="element-91" data-mp="d0nmrn4j4rqs">
        {/* Contact Info */}
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} animate={{
        opacity: 1,
        x: 0
      }} className="bg-white rounded-lg shadow-md p-6 md:p-8" data-id="element-92" data-mp="83dmtdjikxop">
          <h2 className="text-2xl font-semibold mb-6 text-[#2A4B7C]" data-id="element-93" data-mp="3qg230eluuflm">
            Get in Touch
          </h2>

          <div className="space-y-6" data-id="element-94" data-mp="3lh8lmb3g64g6">
            <div className="flex items-start gap-4" data-id="element-95" data-mp="3lg7cwd9wlu1m">
              <MailIcon className="text-[#1B2A4A] mt-1 flex-shrink-0" size={24} data-id="element-96" data-mp="3gh454l2jh9py" />
              <div className="min-w-0" data-id="element-97" data-mp="36t8lgib1qzmw">
                <h3 className="font-semibold mb-1 text-[#111827]" data-id="element-98" data-mp="36wcy842kv3p6">
                  {t.contact.emailLabel}
                </h3>
                <a href={`mailto:${t.contact.email}`} className="text-[#1B2A4A] hover:text-amber-600 transition-colors break-all" data-id="element-99" data-mp="2xttw5m6m8v3z">
                  {'reference.studentjournal@gmail.com\n'}
                </a>
              </div>
            </div>
          </div>
        </motion.div>

        {/* Contact Form */}
        <motion.div initial={{
        opacity: 0,
        x: 20
      }} animate={{
        opacity: 1,
        x: 0
      }} className="bg-white rounded-lg shadow-md p-6 md:p-8" data-id="element-100" data-mp="3ulp7f3xwnbrh">
          <h2 className="text-2xl font-semibold mb-6 text-[#2A4B7C]" data-id="element-101" data-mp="cdpun36agwpf">
            {t.contact.formTitle}
          </h2>

          <form onSubmit={handleSubmit} className="space-y-6" data-id="element-102" data-mp="h5hphpwh9old">
            <div data-id="element-103" data-mp="21ulfz0qljgi7">
              <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-104" data-mp="21u1yfl4uyu4p">
                {t.contact.nameLabel}
              </label>
              <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} placeholder={t.contact.namePlaceholder} required className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-[#1B2A4A] focus:border-transparent outline-none" data-id="element-105" data-mp="2bjvaen8wxb9h" />
            </div>

            <div data-id="element-106" data-mp="1ss2g8pi3xk06">
              <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-107" data-mp="1nvlsvxiqf9o5">
                Email
              </label>
              <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} placeholder={t.contact.emailPlaceholder} required className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-[#1B2A4A] focus:border-transparent outline-none" data-id="element-108" data-mp="34bev6bl5qxdl" />
            </div>

            <div data-id="element-109" data-mp="1mty48fb5fkgi">
              <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-110" data-mp="1mug7vx0550yg">
                {t.contact.messageLabel}
              </label>
              <textarea id="message" name="message" value={formData.message} onChange={handleChange} placeholder={t.contact.messagePlaceholder} required rows={5} className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-[#1B2A4A] focus:border-transparent outline-none resize-none" data-id="element-111" data-mp="1wp85v1xmxptr" />
            </div>

            <button type="submit" className="w-full text-white px-6 py-3 rounded-md hover:bg-[#2a3a5a] transition-colors font-medium bg-[#2A4B7C]" data-id="element-112" data-mp="2pmk4fubrsojm">
              {t.contact.sendButton}
            </button>
          </form>
        </motion.div>
      </div>
    </div>;
}